import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios';
import { Url } from '../Url';
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'

const FViewPedido = () => {
    const [total, setTotal] = useState(0)
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [medio1, setMedio1] = useState('1')
    const [medio2, setMedio2] = useState('4')
    const [importe1, setImporte1] = useState('')
    const [importe2, setImporte2] = useState('')
    const [procesando, setProcesando] = useState(false)
    const [entregado, setEntregado] = useState(false)
    const { pedidoSelected, idUsuario } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])


    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof pedidoSelected.productos !== 'undefined') {
                pedidoSelected.productos.forEach(element => {
                    t = t + parseInt(element.monto)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [pedidoSelected])

    const handleEntrega = async () => {
        setProcesando(true)
        const formData = new FormData()
        formData.append("id", pedidoSelected.idpedido)
        formData.append("idusuario", idUsuario)
        formData.append('mediopago', medioPago);
        formData.append('medio1', medio1);
        formData.append('medio2', medio2);
        formData.append('total', total);
        try {
            const response = await axios({
                url: Url + 'api/entrega.php',
                method: 'POST',
                data: formData,
            })
            console.log(response)
            setEntregado(true)
            //setPedidos(response.data.results)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className="w-full py-5 px-2 md:px-20 rounded-2xl" ref={componentRef}>
            <h2 className='text-center text-gray-700 text-xl'>Pedido</h2>
            <p className='text-center'><span className='font-semibold'>Cliente:</span> {pedidoSelected.cliente}</p>
            <p className='text-center'><span className='font-semibold'>Fecha y hora de Pedido:</span> {pedidoSelected.fechapedido} | {pedidoSelected.horapedido}</p>
            <div className='bg-gray-50 rounded-lg p-1 sm:p-5 sm:w-1/2 mx-auto'>
                {typeof medios !== 'undefined' && medios.map((item, index) =>
                    <div key={index} className="radio">
                        <label>
                            <input
                                type="radio"
                                name="medioPago"
                                value={item.id}
                                checked={medioPago === item.id}
                                onChange={() => setMedioPago(item.id)}
                                className='mr-5'
                            />
                            {item.descripcion}
                        </label>
                    </div>
                )}
            </div>
            {medioPago === '7' && (
                <>
                    <div className='w-full mt-5 bg-blue-50 rounded-lg p-5'>
                        <p className='text-xl font-bold'>Medio de Pago 1</p>
                        <div className='rounded-lg p-5 sm:w-1/2'>
                            {typeof medios !== 'undefined' && medios.map((item, index) =>
                                /*item.id !== '7' &&*/
                                item.id === '1' &&
                                <div key={index} className="radio">
                                    <label>
                                        <input
                                            type="radio"
                                            name="medioPago1"
                                            value={item.id}
                                            checked={medio1 === item.id}
                                            onChange={() => setMedio1(item.id)}
                                            className='mr-5'
                                        />
                                        {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                    </label>
                                </div>
                            )}
                            <label className="block text-gray-800" htmlFor='importe1'>Importe Medio de Pago 1</label>
                            <input
                                type='text'
                                className={`p-2 rounded border border-gray-400 w-full ${importe1 > total ? 'bg-red-300' : 'bg-white'}`}
                                value={importe1}
                                id="importe1"
                                onChange={(e) => setImporte1(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='w-full mt-5 mb-10 bg-blue-50 rounded-lg p-5'>
                        <p className='text-xl font-bold'>Medio de Pago 2</p>
                        <div className='mt-2 rounded-lg p-5 sm:w-1/2'>
                            {typeof medios !== 'undefined' && medios.map((item, index) =>
                                /*item.id !== '7' && item.id !== medio1 &&*/
                                item.id === '4' &&
                                <div key={index} className="radio">
                                    <label>
                                        <input
                                            type="radio"
                                            name="medioPago2"
                                            value={item.id}
                                            checked={medio2 === item.id}
                                            onChange={() => setMedio2(item.id)}
                                            className='mr-5'
                                        />
                                        {item.descripcion} {item.id === '3' && '(20% de recargo con éste medio)'}
                                    </label>
                                </div>
                            )}
                            <label className="block text-gray-800" htmlFor='importe2'>Importe Medio de Pago 2</label>
                            <input
                                type='text'
                                className='p-2 rounded border border-gray-400 w-full'
                                value={importe2}
                                id="importe2"
                                onChange={(e) => setImporte2(e.target.value)}
                            />
                        </div>
                    </div>
                </>
            )}
            {pedidoSelected.productos && (
                <table className='w-full md:w-3/4 mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Cantidad</th>
                            <th>Producto</th>
                            <th>Monto</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            pedidoSelected.productos.map((item, index) => (
                                <tr key={index} className='border border-gray-300 p-2 text-center'>
                                    <td>{item.cantidad}</td>
                                    <td>{item.descripcion}</td>
                                    <td>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center'>
                            <th colSpan={2}>Total</th>
                            <th>$ {parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</th>
                        </tr>
                    </tbody>
                </table>
            )}

            <div className="w-full rounded-lg px-3 flex justify-center mt-10 print:hidden">
                {!entregado && (
                    <button
                        type="button"
                        className={`w-1/4 sm:w-1/6 shadow-md p-3 ml-3 text-white transition-all uppercase font-bold rounded-lg ${!procesando ? 'bg-orange-500 hover:bg-orange-400' : 'bg-orange-100'}`}
                        onClick={() => handleEntrega()}
                        disabled={procesando}
                    >
                        Confirmar Entrega
                    </button>
                )}
                <Link
                    className="w-1/4 sm:w-1/6 shadow-md p-3 text-center ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    to={"/pedidos"}
                >
                    Volver a Pedidos
                </Link>
            </div>
        </div>
    )
}

export default FViewPedido